import React from 'react';
import dayjs from 'dayjs';
import { Typography } from 'ui';
import { Color, TypeScales } from 'ui/primitives';
import { StarRating } from 'ui';
import s from './ReviewCard.module.scss';

type ReviewCardType = {
  title: string;
  rating: number;
  description: string;
  name: string;
  date: Date;
};

export const ReviewCard = ({
  title,
  rating,
  description,
  name,
  date,
}: ReviewCardType) => {
  return (
    <div className={s.root}>
      <div className={s.top}>
        <Typography label={title} variant={TypeScales.h4} className={s.heading} />
        <StarRating totalRating={5} currentRating={rating} />
      </div>
      <Typography
        label={description}
        variant={TypeScales.body_para_m}
        color={Color.text_subheading}
        className={s.description}
      />
      <Typography label={name} variant={TypeScales.h5} className={s.name} />
      <Typography
        label={`on ${dayjs(date).format('MMM DD YYYY')}`}
        color={Color.text_subheading}
      />
    </div>
  );
};
